import { render, staticRenderFns } from "./AppHeaderStudentMenu.vue?vue&type=template&id=7b6af350&lang=pug"
import script from "./AppHeaderStudentMenu.vue?vue&type=script&lang=js"
export * from "./AppHeaderStudentMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports